import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PortalBannerItem extends Component {
  render () {
    const { event, isInnerType, index } = this.props;
    const linkUrl = event.get('linkType') === 'eventpage' ? `/portal/events/${event.get('id')}` : event.get('url');
    const imageUrl = isInnerType ? event.get('eventImageUrl') : event.get('bannerImageUrl');
    const bgColor = (isInnerType ? event.get('eventImageBgHex') : event.get('bannerImageBgHex')) || '#FFFFFF';
    return (
      <div className={`@0-${index}`}>
        <a href={isInnerType ? undefined : linkUrl}
           className="link_bnr" style={{ backgroundColor: bgColor }}
           data-tiara-ordnum={index}
        >
          <img src={imageUrl} className="img_bnr" alt={event.get('title')} />
        </a>
      </div>
    );
  }
}

PortalBannerItem.propTypes = {
  event: PropTypes.object.isRequired,
  isInnerType: PropTypes.bool,
  index: PropTypes.number
};

PortalBannerItem.defaultProps = {
  isInnerType: false,
  index: 0
};


// WEBPACK FOOTER //
// ./src/components/PortalBanner/PortalBannerItem.js